export const DEFAULT_DOCUMENTS_CONFIG = {
  oracleConnectionGuide: {
    title: "Candor Oracle Database Connection Guide",
    filename: "Oracle Database _ UserGuide.pdf",
    url: "/documents/Oracle Database _ UserGuide.pdf"
  },
  etlScriptGuide: {
    title: "Candor ETL Script Generation and Execution Guide",
    filename: "ETL_userguide.pdf",
    url: "/documents/ETL_userguide.pdf"
  }
};

/**
 * Dynamically fetches document configuration from public/documents/documents_config.json.
 * This allows editing titles, URLs, and filenames after production build without recompiling.
 */
export async function fetchDocumentsConfig() {
  const publicUrl = process.env.PUBLIC_URL || '';
  const configUrl = `${publicUrl}/documents/documents_config.json?v=${Date.now()}`;
  try {
    const response = await fetch(configUrl, { cache: 'no-store' });
    if (response.ok) {
      const data = await response.json();
      return {
        ...DEFAULT_DOCUMENTS_CONFIG,
        ...data
      };
    }
  } catch (err) {
    console.warn("Could not load dynamic documents_config.json, using default configuration:", err);
  }
  return DEFAULT_DOCUMENTS_CONFIG;
}
